import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { isSafari } from '../../util/browserDetection';

function PWAInstallInstructionForIOSBottomSheet() {
    const { t } = useLanguage();
    const isSafariBrowser = isSafari();

    return (
        <div
            className="offcanvas offcanvas-bottom ios-install-sheet"
            id="ios-install-sheet"
            tabIndex="-1"
        >
            <div className="offcanvas-header padding-bottom-0">
                <div className="ios-app-info">
                    <img src="/assets/images/logo/coin.png" className="ios-app-icon" alt="Xpenso" />
                    <div>
                        <h4 className="ios-title">Xpenso</h4>
                        <p className="ios-subtitle">{t('installXpensoToHomeScreen')}</p>
                    </div>
                </div>
                <button
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                ></button>
            </div>
            <div className="offcanvas-body ios-sheet-body padding-top-10">
                <div className="install-step">
                    <button className="ios-action-btn form-group">
                        {t('clickShareIcon')}
                        <img
                            className="active"
                            src={'/assets/images/svg/share-ios-export-svgrepo-com.svg'}
                            alt="Share"
                        />
                    </button>

                    <button className="ios-action-btn form-group">
                        {t('addToHomeScreen')}
                        <img
                            className="active"
                            src={'/assets/images/svg/add-to-queue-svgrepo-com.svg'}
                            alt="Home"
                        />
                    </button>
                </div>

                <div className="ios-slider-wrapper">
                    <div className="ios-slider">
                        <img
                            src={
                                isSafariBrowser
                                    ? '/assets/images/share41.png'
                                    : '/assets/images/share31.png'
                            }
                            className="ios-slide"
                            alt="Share"
                        />
                        <img
                            src={
                                isSafariBrowser
                                    ? '/assets/images/share42.png'
                                    : '/assets/images/share42.png'
                            }
                            className="ios-slide"
                            alt="Add To Home"
                        />
                        <img
                            src={
                                isSafariBrowser
                                    ? '/assets/images/share43.png'
                                    : '/assets/images/share43.png'
                            }
                            className="ios-slide"
                            alt="Add"
                        />
                    </div>

                    <div className="ios-slider-dots">
                        <span className="dot active"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PWAInstallInstructionForIOSBottomSheet;
